import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Galerie from "../Galerie/Galerie";
import Icons from "../../utils/icons";
import MyGoogleMap from '../../Components/Map/map'

export default function Appartement({ detail }) {

    return detail ? (
    <div className="p-10 bg-white rounded-lg shadow-md dark:bg-gray-800">
        {/* Titre principal */}
        <p className="p-5 mt-5 text-3xl font-bold text-gray-800 animate-fade-right dark:text-gray-200">Détails du bien</p>

        {/* Contenu principal */}
        <div className="grid items-start grid-cols-12 gap-10 animate-fade-left">

            {/* Image principale */}
            <div className="col-span-12 p-4 md:col-span-6">
            <div className="overflow-hidden rounded-lg shadow-md">
                <img alt="" src={`${process.env.REACT_APP_API_PICTURE_URL}${detail.picture}`} className="w-full" />
            </div>
            </div>

            {/* Informations principales */}
            <div className="col-span-12 p-4 md:col-span-6">
            <div className="space-y-4">
                <div className="flex items-center">
                    <span className="text-xl font-semibold text-gray-800 dark:text-gray-200">Type :</span>
                    <span className="ml-2 text-gray-600 dark:text-gray-200">{detail.type[0].name}</span>
                </div>

                <div className="flex items-center">
                    <span className="text-xl font-semibold text-gray-800 dark:text-gray-200">Prix :</span>
                    <span className="ml-2 text-gray-600 dark:text-gray-200">{detail.price} XAF / {detail.periodPrice}</span>
                </div>

                <div className="flex items-center">
                    <span className="text-xl font-semibold text-gray-800 dark:text-gray-200">Adresse :</span>
                    <span className="ml-2 text-gray-600 dark:text-gray-200">{detail.address}, {detail.town}, {detail.country}</span>
                </div>

                <div className="flex mt-3 space-x-2">
                    <span className="px-3 py-1 font-bold text-purple-800 bg-purple-600 rounded-full bg-opacity-15">Meublé</span>
                    <span className="px-3 py-1 font-bold text-green-800 bg-green-600 rounded-full bg-opacity-15">Libre</span>
                </div>  
            </div>

            {/* Détails supplémentaires */}
            <div className="mt-6 space-y-4">
                <div className="flex items-center space-x-6">
                <div className="flex items-center">
                    <FontAwesomeIcon icon={Icons.bed} className="mr-2 text-purple-800" />
                    <p className="text-gray-600 dark:text-gray-200">{detail.bed} lits</p>
                </div>

                <div className="flex items-center">
                    <FontAwesomeIcon icon={Icons.bath} className="mr-2 text-purple-800" />
                    <p className="text-gray-600 dark:text-gray-200">{detail.bath} salles de bains</p>
                </div>

                <div className="flex items-center">
                    <FontAwesomeIcon icon={Icons.car} className="mr-2 text-purple-800" />
                    <p className="text-gray-600 dark:text-gray-200">{detail.room} chambres</p>
                </div>
                </div>
            </div>

            {/* Services supplémentaires */}
            <div className="mt-6">
                <p className="text-xl font-semibold text-gray-800 dark:text-gray-200">Ce que propose ce logement :</p>
                <ul className="pl-5 mt-2 space-y-1 text-gray-600 list-disc dark:text-gray-200">
                <li>Connexion wifi</li>
                <li>Climatisation</li>
                <li>Cuisine équipée</li>
                <li>Parking</li>
                </ul>
            </div>

            {/* Bouton d'action */}
            <div className="mt-6">
                <button className="w-full py-3 text-white transition bg-purple-800 rounded-lg shadow-md hover:bg-purple-700">
                Modifier
                </button>
            </div>
            </div>

            <div className="col-span-12 p-8">
                <p className="mb-5 text-xl font-semibold text-gray-800 dark:text-gray-200">Description</p>
                <p className="text-gray-700 dark:text-gray-200">{detail.desc}</p>
            </div>

            {/* Galerie */}
            <div className="col-span-12 p-8">
            <p className="mb-5 text-xl font-bold text-gray-800 dark:text-gray-200">Galerie</p>
                {
                    detail.gallery.length > 0 ? (
                    <Galerie galeries={detail.gallery} />
                    ) : (
                    <div className="flex items-center justify-center h-64 text-center text-gray-600">
                        <p className="text-xl font-medium dark:text-gray-200">Aucune galerie trouvée.</p>
                    </div>
                    )
                }
            </div>

            {/* Emplacement */}
            <div className="col-span-12 p-8">
                <p className="mb-5 text-xl font-bold text-gray-800 dark:text-gray-200">Emplacement</p>
            <div className="p-5 bg-white rounded-lg dark:bg-gray-700">
                {detail.lat && detail.long && (
                <MyGoogleMap lat={detail.lat} long={detail.long} />
                )}
            </div>
            </div>
        </div>
    </div>

    ) : null
}